import { ActionTree } from 'vuex';
import { IState } from '../types';
import { IRootState } from '@/store/types';
import vue from '@/main';

const actions: ActionTree<IState, IRootState> = {
  getResources({ commit }) {
    return new Promise((resolve, reject) => {
      window.apis
        .getSlideshow<IState>()
        .then((res) => {
          commit('setResources', res.data);
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  turnOnCamera({ commit }) {
    commit('setCameraOn', true);
    vue.$PostConnection?.command('change_camera_state', true);
  }
};

export default actions;
